import { Button, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import * as React from 'react';
import { getExterior360ImageSet } from '../../store/car-slice';
import { carStatusSet } from '../../store/car-slice';
import { useDispatch, useSelector } from 'react-redux';
import { exitFullscreen } from '../../utils/fullscreen';

// Inspired by the former Facebook spinners.
function FacebookCircularProgress() {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        size={40}
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        thickness={4}
        value={100}
        variant="determinate"
      />
      <CircularProgress
        disableShrink
        size={40}
        sx={{
          animationDuration: '550ms',
          color: (theme) =>
            theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
          left: 0,
          position: 'absolute',
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        thickness={4}
        variant="indeterminate"
      />
    </Box>
  );
}
type PropTypes = {
  content?: number;
  loadingMessage?: string;
};

export default function Loading({ content }: PropTypes) {
  const exterior360Image = useSelector(getExterior360ImageSet);

  const { palette }: any = useTheme();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(carStatusSet('VDP'));
    exitFullscreen();
  };

  return (
    <Box
      sx={{
        alignContent: 'center',
        backgroundImage: `url(${exterior360Image?.[0]})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        display: 'grid',
        flexGrow: 1,
        height: '100%',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        zIndex: (theme) => theme.zIndex.tooltip + 1,
      }}
    >
      <Box
        sx={{
          alignContent: 'center',
          backdropFilter: 'blur(10px)',
          display: 'grid',
          flexGrow: 1,
          height: '100%',
          justifyContent: 'center',
          position: 'absolute',
          width: '100%',
        }}
      >
        <Box display={'flex'} justifyContent={'center'}>
          <FacebookCircularProgress />
        </Box>
        {content}
        <Button
          onClick={handleClose}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
            color: palette.primary.main,
            fontSize: '14px',
            fontWeight: 700,
          }}
          variant="text"
        >
          Back
        </Button>
      </Box>
    </Box>
  );
}
